// extracted by mini-css-extract-plugin
export default {"paperHeader":"PaperHeader_paperHeader__vFE3a"};